import { formatMoneyShort } from "@/components/Plan/MoneyInput";
import { formatMoneyShortBare } from "@/lib/money";
import { AttainmentLine } from "./ActualsCell";

interface Props {
  past: boolean;
  // Plan revenue (planned units × target ASP).
  plan: number;
  // Real revenue from sales; read for past months in Plan-vs-Actual mode.
  actual: number;
  showActuals: boolean;
  monthDividers: boolean;
  top: number;
  planCurrency?: string | null;
}

// One month's cell in the grid's sticky "Revenue" header row.
export default function MonthRevenueHeaderCell({ past, plan, actual, showActuals, monthDividers, top, planCurrency }: Props) {
  return (
    <th
      style={{
        background: past ? "var(--border)" : "var(--muted)",
        color: "var(--foreground)",
        boxShadow: "0 -1px 0 0 var(--border), 0 1px 0 0 var(--border)",
        top,
        ...(monthDividers ? { borderColor: "var(--accent)" } : {}),
      }}
      className={`sticky z-20 px-2 py-2 text-right font-semibold whitespace-nowrap${monthDividers ? " border-r" : ""}`}
    >
      {showActuals && past ? (
        (plan > 0 || actual > 0) && (
          // Actual/plan pair + attainment, matching the product cells' format.
          <span
            className="block text-left font-normal tabular-nums"
            style={{ color: "var(--muted-foreground)" }}
            title="Actual revenue (from sales) / plan revenue · attainment"
          >
            <span className="font-semibold" style={{ color: "var(--foreground)" }}>
              {formatMoneyShortBare(actual, planCurrency)}
            </span>
            {plan > 0 && <>/{formatMoneyShortBare(plan, planCurrency)}</>}
            {plan > 0 && <AttainmentLine actual={actual} plan={plan} />}
          </span>
        )
      ) : (
        formatMoneyShort(plan, planCurrency)
      )}
    </th>
  );
}
